module.exports = __webpack_public_path__ + "img/SISTG.db610929.gif";